export { default } from "./TimelineDot.js";
export { default as timelineDotClasses } from "./timelineDotClasses.js";
export * from "./timelineDotClasses.js";